<meta-title i18n>התחברות למערכת הרישום</meta-title>

<div class="auth-page">
  <ui-error [state]="loadState"></ui-error>

  <header class="auth-page-header">
    <h2 i18n>כניסה למערכת ההרשמה</h2>
  </header>

  <div class="auth-card">
    <form [formGroup]="form" novalidate autocomplete="off" (submit)="identify()">
      <identity-key-field [form]="form" [loadState]="loadState">
        <p identityKeyHint class="auth-hint" i18n>
          נא וודא ש{method, select, idNumber {תעודת הזהות הינה} passport {הדרכון הינו}} של הנירשם ולא של מישהו אחר
        </p>
      </identity-key-field>

      <div class="auth-form-actions">
        <ui-progress-button
          class="auth-submit"
          color="primary"
          [disabled]="form.invalid || !loadState.isCompleted"
          [state]="identifyState"
          i18n
        >
          {identifyState.value, select, inProcess {ממשיכים} other {המשך}}
        </ui-progress-button>
      </div>

      <p class="auth-footer-note">
        <a class="auth-inline-link" routerLink="/reset-process/identify" i18n> שכחת את הסיסמה? </a>
      </p>

      <div class="auth-alert" *visible="identifyState.error?.isInvalidModel" i18n>
        {method, select, idNumber {תעודת הזהות} passport {מספר הדרכון}}
        שהזנת אינה תקינה
      </div>

      <ui-error [state]="identifyState" [ignoreList]="[400]"> </ui-error>
    </form>
  </div>
</div>
